<template>
<div>
    <div class="heading">
        <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
        <p v-show="displaypromotion" v-html="promotiontext"></p>
        <p v-show="displaybookingprocess" v-html="bookingprocess"></p>
        <p v-show="displaybookingform" >
          <Eventticket/>
        </p>
        
        <img class="dividerline" src="../assets/img/sep.png" alt="">
        
        <h2>Events throughout the year </h2>
        <img class="dividerline" src="../assets/img/sep.png" alt="">
        
        <div class="heading">
            <ul style="text-align:left" v-for="(data, i) in eventdetails" :key="i+50">
                <li v-html="data"></li>
            </ul>
            <img class="dividerline" src="../assets/img/sep.png" alt="">
        </div>
    </div>
            <div v-html="pasteventpics"></div>
</div>


</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import Eventticket from '@/components/sections/Eventticket'
  export default {
    name: 'Events',
    components: {
    Loading,
    Eventticket
    },
    data () {
      return {
        msg: 'Events',
        isLoading: false,
        fullPage: true,
        info: null,
        eventdetails: null,
        pasteventpics: null,
        displaypromotion:false,
        promotiontext:null,
        displaybookingform:false,
        displaybookingprocess:false,
        bookingprocess:null,
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            }
  },
  mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/events')
      .then(response => {
        this.info = response.data
        this.eventdetails=this.info[0].eventdetails
        this.pasteventpics=this.info[0].pasteventpics
        this.displaypromotion=this.info[0].displaypromotion
        this.promotiontext=this.info[0].promotiontext
        this.displaybookingform=this.info[0].displaybookingform
        this.displaybookingprocess=this.info[0].displaybookingprocess
        this.bookingprocess=this.info[0].bookingprocess
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Events.vue